import styled from 'styled-components'

import { AppName, Color } from 'root-constants'

import { FLOW_THEMES } from './themes'

export const StyledFlowScope = {
  Wrapper: styled.div<{ appName: AppName }>`
    min-height: var(--full-height, 100vh);
    background-color: ${Color.WHITE};

    ${({ appName }) => FLOW_THEMES[appName]};
  `,
}
